import { IIssueMachineHealthResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildFilterExpression, IssueFilter } from 'pages/Desk/issues/shared';
import { GroupIssueMetricsDataSourceKey } from 'pages/workbench/side_panel/workbench_tree/modals/useGroupIssueMetrics';
import { queryClient } from 'utils/query';
import { buildOrderBy, toDataSourceResult } from 'utils/query_v3';

export const MachineHealthIssuesDataSourceKey = 'machine-health-issues';

export type UseMachineHealthIssuesDataSourceOptions = BaseDataSourceOptions<
    IIssueMachineHealthResponse,
    IssueFilter
>;

export type MachineHealthIssuesPagedDataSource = PagedDataSource<
    IIssueMachineHealthResponse,
    IssueFilter
>;

export type MachineHealthIssuesInfiniteDataSource = InfiniteDataSource<
    IIssueMachineHealthResponse,
    IssueFilter
>;

const getAllIssues: DataSourceQuery<IIssueMachineHealthResponse, IssueFilter> = ({
    filter,
    sort,
    page,
    pageLimit,
}) => {
    const filterExpr = buildFilterExpression('machineHealth', filter);
    const orderBy = buildOrderBy(sort, {
        invert: ['Priority'],
        descNullsLast: ['LastActivity', 'DateResolved'],
    });
    return toDataSourceResult(
        sdClient.getMachineHealthIssues({
            groupIds: filter.hierarchyGroupIds,
            filter: filterExpr,
            page,
            pageLimit,
            orderBy,
        })
    );
};

export function usePagedMachineHealthIssuesDataSource({
    ...options
}: UseMachineHealthIssuesDataSourceOptions): MachineHealthIssuesPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: getAllIssues,
    });
}

export function useInfiniteMachineHealthIssuesDataSource({
    ...options
}: UseMachineHealthIssuesDataSourceOptions): MachineHealthIssuesInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: getAllIssues,
    });
}

export function invalidateMachineHealthIssuesDataSource() {
    queryClient.invalidateQueries({
        queryKey: [MachineHealthIssuesDataSourceKey],
    });
    queryClient.invalidateQueries({
        queryKey: [GroupIssueMetricsDataSourceKey],
    });
}
